import React from 'react';
import { RadioGroup as MSRadioGroup, RadioGroupProps } from '@fluentui/react-northstar';

const RadioGroup = (props: RadioGroupProps) => <MSRadioGroup {...props} />;

export default RadioGroup;
